export default __webpack_public_path__ + "static/media/sports18.13d2d7e7.jpg";